const lerpArray = (startArray, endArray, amount) => {
  const newArray = [];
  for (let i = 0; i < startArray.length; i++) {
    newArray.push((1-amount)*startArray[i]+amount*endArray[i])
  }
  return newArray;
}

export default lerpArray;